import 'nprogress/nprogress.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { FeatureFlagProvider } from 'switch-fe-shared/hooks/useFeatureFlag';
import { RemoteConfigProvider } from 'switch-fe-shared/hooks/useRemoteConfig';

import App from './App';
import { AuthProvider } from './auth';
import { remoteConfig } from './auth/clients/firebase/FirebaseAuthProvider';
import { SidebarProvider } from './context/SidebarContext';
import { useAppSelector } from './hooks/hooks';
import useEffectiveApplicationGroupId from './hooks/useEffectiveApplicationGroupId';
import { useOrganisation } from './hooks/useOrganisation';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const FeatureFlagContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const organisation = useOrganisation();
  const groupId = useEffectiveApplicationGroupId();
  const userEmail = useAppSelector(
    (state) => state.user.user?.email ?? state.user.switchUser?.email ?? null
  );

  return (
    <FeatureFlagProvider
      value={{
        organisation,
        groupId,
        email: userEmail,
      }}
    >
      {children}
    </FeatureFlagProvider>
  );
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <SidebarProvider>
          <BrowserRouter
            future={{
              v7_relativeSplatPath: true,
            }}
          >
            <RemoteConfigProvider remoteConfig={remoteConfig}>
              <AuthProvider>
                <FeatureFlagContextProvider>
                  <App />
                </FeatureFlagContextProvider>
              </AuthProvider>
            </RemoteConfigProvider>
          </BrowserRouter>
        </SidebarProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
